// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__mW3ft","balanceDisclaimer":"posDashboard_balanceDisclaimer__1T9NM"};